import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getServerInfoConfig} from 'api/requests/courierExpress';
import {QueryKeyEnum} from 'types';

type ServerConfigResponse = {
  show_courier_express: boolean;
  maintenance_mode: boolean;
  cola_promo_active: boolean;
  cola_promo_threshold: number;
  maib_disabled: boolean;
  bpay_disabled: boolean;
  whatsapp_login: boolean;
};

export const useServerConfig = (options?: UseQueryOptions<ServerConfigResponse>) => {
  return useQuery<ServerConfigResponse>({
    queryKey: [QueryKeyEnum.SERVER_INFO_CONFIG],
    queryFn: () => getServerInfoConfig(),
    staleTime: 5 * 60 * 1000, // 5 minutes - config doesn't change often
    ...options,
  });
};
